export default __webpack_public_path__ + "static/media/social.6a0349db.svg";